<template>
  <div class="ui-pannel">
    <p class="title">{{ $t('user.invite') }}</p>
    <div class="content">
      <div class="inviter">
        {{ $t('student') }}{{ $t('colon') }}{{ checkInfo.name
        }}<span style="margin-left: 20px"
          >{{ $t('common.course') }}{{ $t('colon')
          }}{{ checkInfo.course }}</span
        >
      </div>
      <div class="wrap">
        <div class="topic-box">
          <a class="pre" @click="preWeek">{{ $t('weeks.pre') }}</a>
          <p class="topic">{{ $t('weeks.title') }}</p>
          <a class="next" @click="nextWeek">{{ $t('weeks.next') }}</a>
        </div>
        <ul class="dates">
          <li v-for="i in 7" :key="i">
            <div v-if="$t('weeks.today') === dateArr[i - 1].show">
              <p class="date">{{ dateArr[i - 1].show }}</p>
              <p class="week">{{moment(new Date()).format('DD/MM')}}</p>
            </div>
            <div v-else>
              <p class="date">{{ dateArr[i - 1].week }}</p>
              <p class="week">{{ dateArr[i - 1].show }}</p>
            </div>
          </li>
        </ul>
        <ul class="times">
          <li v-for="i in 7" :key="i">
            <p
              v-for="(cell, index) in timeArr[i - 1]"
              :key="index"
              @click="order(i - 1, index, timeArr[i - 1])"
              :class="{ disable: cell.state === 1, fulled: cell.state === 2 }"
            >
              {{ cell.time }}
            </p>
            <div
              class="booked"
              v-for="(n,index) in booked[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">已预约</span> -->
            </div>
            <div
              class="order"
              v-for="(n,index) in newOrder[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">预约</span> -->
            </div>
            <div
              class="full"
              v-for="(n,index) in full[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">已满</span> -->
            </div>
          </li>
        </ul>
        <div class="foot">
          <a class="ui-btn ligh" @click="reset">{{ $t('common.reset') }}</a>
          <a class="ui-btn" @click="submit">{{ $t('common.submit') }}</a>
          <a class="ui-btn gray" @click="$router.go(-1)">{{ $t('cancel') }}</a>
        </div>
      </div>
    </div>
    <check
      :info="checkInfo"
      @comfirm="comfirm"
      @refuse="checkInfo.show = false"
    />
  </div>
</template>
<script>
import getTimeArr from '@/data.js'
import moment from 'moment'
import {
  getTeacherAppointedTimeList,
  askCourse,
  getBaseProfile,
} from '@/service/teacherApi.js'
import { getCourseList } from '@/service/api.js'
import { getStudentStudyCourseList } from '@/service/studentApi.js'
import check from '@/components/Check.vue'
export default {
  components: { check },
  data() {
    return {
      moment,
      timeArr: [],
      newOrder: [[], [], [], [], [], [], []],
      booked: [[], [], [4], [], [], [], []],
      full: [[], [], [], [3], [], [5], []],
      currentDay: '',
      dateArr: [
        { date: '', show: '', week: this.$t('weeks.mon') },
        { date: '', show: '', week: this.$t('weeks.tues') },
        { date: '', show: '', week: this.$t('weeks.wed') },
        { date: '', show: '', week: this.$t('weeks.thur') },
        { date: '', show: '', week: this.$t('weeks.fri') },
        { date: '', show: '', week: this.$t('weeks.sat') },
        { date: '', show: '', week: this.$t('weeks.sun') },
      ],
      checkInfo: {
        show: false,
        type: 2,
        name: '王同学',
        list: [
          { week: '周四', dateTime: '2019-01-01 19:00 --20:00', num: 2 },
          { week: '周五', dateTime: '2019-01-02 19:00 --20:00', num: 2 },
        ],
        cancel: '取消',
        comfirm: '确定',
        course: '',
      },
      info: {},
      courseList: [],
    }
  },
  methods: {
    async getCourseList() {
      let res = await getCourseList()
      if (res.data.status === 1) {
        this.courseList = res.data.data
      }
    },
    async getBaseProfile() {
      let res = await getBaseProfile({ teacherId: this.user.uid })
      if (res.data.status === 1) {
        this.info = res.data.data
      }
    },
    async showOrderList() {
      this.booked = [[], [], [], [], [], [], []]
      this.full = [[], [], [], [], [], [], []]
      const beginTime = moment(this.dateArr[0].date).format('X')
      const endTime = moment(this.dateArr[6].date).endOf('date').format('X')
      const res = await getTeacherAppointedTimeList({
        teacherId: this.$route.query.id,
        beginTime: beginTime,
        endTime: endTime,
      })
      if (res.data.status === 1) {
        this.setDisable(res.data.data)
      }
      const res2 = await getStudentStudyCourseList({
        beginTime: beginTime,
        endTime: endTime,
      })
      if (res2.data.status === 1) {
        this.setDisable(res2.data.data)
      }
    },
    setDisable(data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < 7; j++) {
          if (
            moment(data[i].beginTime * 1000).format('YYYYMMDD') ===
            moment(this.dateArr[j].date).format('YYYYMMDD')
          ) {
            let n =
              (moment(data[i].beginTime * 1000).format('X') -
                moment(this.dateArr[j].date).format('X')) /
              900
            if (this.user.uid === data[i].teacherId) {
              this.booked[j].push(n)
            } else {
              this.full[j].push(n)
            }
          }
        }
      }
      let arr = this.booked.concat(this.full) // 设置不可预约字段
      for (let i = 0; i < 14; i++) {
        if (arr[i].length) {
          for (let j = 0; j < arr[i].length; j++) {
            let n = arr[i][j]
            let y = i
            if (i >= 7) {
              y = i - 7
            }
            for (let x = 0; x < 5; x++) {
              this.timeArr[y][n + x].state = 2
            }
          }
        }
      }
    },
    order(x, y, row) {
      if (row[y].state === 0 && y < row.length - 4) {
        let state = true
        for (let j = 1; j < 5; j++) {
          if (row[y + j].state !== 0) {
            state = false
          }
        }
        if (state) {
          if (this.newOrder[x].length) {
            for (let i = 0; i < this.newOrder[x].length; i++) {
              if (
                (this.newOrder[x][i] - 5 < y && this.newOrder[x][i] > y) ||
                (this.newOrder[x][i] + 5 > y && this.newOrder[x][i] < y)
              ) {
                this.newOrder[x].splice(i, 1)
                i--
              }
            }
          }
          this.newOrder[x].push(y)
        }
      }
    },
    getDay(index) {
      let day = moment(this.currentDay).format('d')
      if (day === 0) {
        day = 7
      }
      let theDay = moment(this.currentDay).subtract(day - index, 'day')
      if (moment(theDay).format('YYYYMMDD') === moment().format('YYYYMMDD')) {
        return '今天'
      } else {
        return moment(theDay).format('MM-DD')
      }
    },
    resetDate() {
      this.timeArr = getTimeArr(0)
      let day = moment(this.currentDay).format('d')
      if (day == 0) {
        day = 7
      }
      for (let i = 0; i < 7; i++) {
        this.dateArr[i].date = moment(this.currentDay)
          .subtract(day - i - 1, 'day')
          .format('YYYY-MM-DD')
        if (
          moment(this.dateArr[i].date).format('YYYYMMDD') ===
          moment().format('YYYYMMDD')
        ) {
          this.dateArr[i].show = this.$t('weeks.today')
        } else {
          this.dateArr[i].show = moment(this.dateArr[i].date).format('DD/MM')
        }
      }
      this.showOrderList()
    },
    preWeek() {
      this.currentDay = moment(this.currentDay)
        .subtract(7, 'day')
        .format('YYYYMMDD')
      this.resetDate()
    },
    nextWeek() {
      this.currentDay = moment(this.currentDay).add(7, 'day').format('YYYYMMDD')
      this.resetDate()
    },
    reset() {
      this.newOrder = [[], [], [], [], [], [], []]
    },
    async comfirm() {
      if (!!this.checkInfo.course) {
        this.info.courseName = this.checkInfo.course
        this.info.courseId = this.courseList.find(
          (item) => item.courseName === this.info.courseName
        ).courseId
      }
      let arr = []
      for (let i = 0; i < this.checkInfo.list.length; i++) {
        arr.push({
          beginTime: this.checkInfo.list[i].start,
          endTime: this.checkInfo.list[i].end,
          courseId: this.info.courseId,
          courseName: this.info.courseName,
          courseCount: 1,
        })
      }
      const res = await askCourse({
        studentId: this.$route.query.id,
        products: JSON.stringify(arr),
      })
      if (res.data.status === 1) {
        this.$message({ message: 'Successful invitation', type: 'success' })
        this.$router.push({ path: '/user/timetable2' })
      }
    },
    submit() {
      this.checkInfo.show = true
      let arr = []
      this.checkInfo.list = []
      for (let i = 0; i < 7; i++) {
        if (this.newOrder[i].length) {
          for (let j = 0; j < this.newOrder[i].length; j++) {
            let time = moment(this.dateArr[i].date).add(
              this.newOrder[i][j] * 15,
              'm'
            )
            let obj = { num: 1 }
            obj.start = moment(time).format('X')
            obj.end = moment(time).add(1, 'hour').format('X')
            obj.dateTime =
              moment(time).format('YYYY-MM-DD HH:mm —— ') +
              moment(time).add(1, 'hour').format('HH:mm')
            obj.week = this.dateArr[i].week
            this.checkInfo.list.push(obj)
          }
        }
      }
    },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  mounted() {
    this.getCourseList()
    this.getBaseProfile()
    this.checkInfo.name = this.$route.query.name
    this.checkInfo.course = this.$route.query.course
    this.currentDay = moment().format('YYYYMMDD')
    this.resetDate()
    // let arr = this.booked.concat(this.full)
    // for(let i = 0; i < 14; i ++){
    //   if(arr[i].length){
    //     for(let j = 0; j < arr[i].length; j ++){
    //       let n = arr[i][j]
    //       let y = i
    //       if(i >= 7){
    //         y = i - 7
    //       }
    //       for(let x = 0; x < 5; x ++){
    //         this.timeArr[y][n + x].state = 2
    //       }
    //     }
    //   }
    // }
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 40px 50px 100px;
}
.inviter {
  height: 50px;
  background: rgba(0, 33, 71, 0.1);
  padding-left: 64px;
  line-height: 50px;
  font-size: 16px;
  color: #333;
}
.wrap {
  margin-top: 40px;
  box-shadow: 0 6px 12px rgba($color: #000000, $alpha: 0.05);
  border-radius: 0 0 12px 12px;
}
.topic-box {
  height: 100px;
  border-bottom: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  padding: 0 50px;
  .topic {
    font-size: 18px;
    line-height: 42px;
    text-align: center;
    flex: 1;
    font-weight: bold;
  }
}
.pre,
.next {
  height: 42px;
  font-size: 16px;
  color: #666;
  line-height: 42px;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 0.9;
  }
}
.pre {
  float: left;
  padding-left: 49px;
  background: url(../assets/arrow_left.png) no-repeat left center;
}
.next {
  float: right;
  padding-right: 49px;
  background: url(../assets/arrow_right.png) no-repeat right center;
}
.dates {
  overflow: hidden;
  border-bottom: 1px solid #d6d6d6;
  padding: 40px 37px 20px;
  li {
    float: left;
    margin: 0 4px;
    width: 100px;
    text-align: center;
    font-size: 16px;
  }
  .date {
    color: #666;
    margin-top: 5px;
  }
}
.times {
  overflow: hidden;
  border-bottom: 1px solid #d6d6d6;
  padding: 0 37px;
  li {
    width: 100px;
    margin: 0 4px;
    padding: 20px 0;
    float: left;
    text-align: center;
    color: #666;
    line-height: 30px;
    position: relative;
  }
  li:nth-child(2n + 1) {
    background: #ebebeb;
  }
  li:nth-child(2n) {
    background: #8a8a8a;
  }
  p {
    position: relative;
    z-index: 1;
    cursor: pointer;
    transition: color 0.3s;
    height: 30px;
    &:hover {
      color: #000;
    }
    &.disable {
      cursor: no-drop;
      color: #cecdcd;
    }
    &.fulled {
      cursor: no-drop;
      color: #666;
    }
  }
}
.booked,
.full,
.order {
  position: absolute;
  left: 0;
  top: 20px;
  right: 0;
  height: 150px;
  border-radius: 20px;
  border: 1px solid #002314;
  padding-left: 78px;
  text-align: left;
  .txt {
    display: inline-block;
    width: 18px;
    font-weight: bold;
    line-height: 19px;
    vertical-align: middle;
    color: #000;
  }
  &:after {
    content: '';
    height: 100%;
    display: inline-block;
    vertical-align: middle;
  }
}
.booked {
  background: #9dada2;
}
.full {
  background: #cacaca;
}
.order {
  background: #4e9cda;
}
.foot {
  padding: 65px 0 80px;
  text-align: center;
  .ui-btn {
    margin: 0 15px;
  }
}
</style>
<i18n>
{
  "cn": {
    "student": "邀约对象"
  },
  "TW": {
    "student": "邀約對象"
  },
  "en": {
    "student": "Invited Student"
  }
}
</i18n>